import * as  React from 'react';
import { connect } from 'react-redux';
import { fetchPublicacion, editPublicacion } from '../../../../actions/publicacionesActions';

class Entrega extends React.Component {
    handleChange = (event) => {
        const { name } = event.target;
        let publicacion = { ...this.props.publicacion };
        publicacion[name] = !publicacion[name];
        this.props.editPublicacion(publicacion);
    }

    render() {
        return (
            <div className="tab-pane p-20 active" name="datos" id="home2" role="tabpanel">
                <div className="row form-group">

                    <div className="col-12 mb-2">
                        <label>Tipo Entrega</label>
                        <div className="row ms-1">
                            <div className="col-12 my-1">
                                <input
                                    id="envioDomicilio"
                                    type="checkbox"
                                    className="me-2"
                                    checked
                                    disabled
                                />
                                <label htmlFor="envioDomicilio">Envio a domicilio</label>
                            </div>
                            <div className="col-12 my-1">
                                <input
                                    type="checkbox"
                                    id="sucursalMegatone"
                                    className="me-2"
                                    disabled
                                />
                                <label htmlFor="sucursalMegatone">Retiro sucursal de Megatone</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 mb-2">
                        <label>Costo de Envío</label>
                        <div className="row ms-1">
                            <div className="col-12 my-1">
                                <input
                                    type="checkbox"
                                    id="envioGratis"
                                    name="envioGratis"
                                    className="me-2"
                                    //disabled={this.props.userType.isAdminMod}
                                    onChange={this.handleChange}
                                    checked={this.props.publicacion.envioGratis}
                                />
                                <label htmlFor="envioGratis">Envio gratis</label>
                            </div>
                            <div className="col-12 my-1">
                                <input
                                    type="checkbox"
                                    id="aCargoComprador"
                                    name="envioGratis"
                                    className="me-2"
                                    //disabled={this.props.userType.isAdminMod}
                                    onChange={this.handleChange}
                                    checked={!this.props.publicacion.envioGratis}
                                />
                                <label htmlFor="aCargoComprador">A cargo del comprador</label>
                            </div>
                            {this.props.publicacion?.seller?.envioPropio &&
                                <div className="col-12 my-1">
                                    <input
                                        type="checkbox"
                                        name="envioPropio"
                                        className="me-2"
                                        onChange={this.handleChange}
                                        disabled={!this.props.userType.isAdminMod && !this.props.userType.isCategory}
                                        defaultChecked={this.props.publicacion.envioPropio}
                                    />
                                    <label htmlFor="logisticaPropia">Logistica Propia</label>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    publicacion: state.publicaciones.publicacion,
    userType: state.general.userType
});

export default connect(mapStateToProps, { fetchPublicacion, editPublicacion })(Entrega);